import React, { useEffect, useState } from "react";
import "./admin-dashboard.css";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { getUserNameFromStoreData } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../../core/store/app-store/app-store";
import http from "../../core/service/http";
import logo from "../../assets/wjcwadmin-logo.png";
import { useAdminDashboardHook } from "./useAdminDashboardHook";
import Footer from "../footer/footer";

const AdminDashboard = () => {
  const { auth, profilePicture, isSidebarOpen, toggleSidebar, handleLogout } = useAdminDashboardHook();

  return (
    <>
      <div className="d-flex flex-column vh-100">
        <div className="d-flex flex-grow-1">
          {/* Sidebar */}
          <div
            className={[
              "d-flex flex-column p-3 text-white bg-gray overflow-auto sidebar-custom ",
              isSidebarOpen ? "open" : "close",
            ].join(" ")}
          >
            <Link
              to="/admin-dashboard"
              className="text-white"
              style={{ textDecoration: "none" }}
            >
              <img
                src={logo}
                alt="User"
                className="rounded-circle mb-2"
                style={{ width: "40px", background: 'white' }}
              />
              <span class="brand-text font-weight-light mx-2">WJCW CF ®</span>
            </Link>
            <hr />
            <div className=" d-flex align-items-center">
              <img
                src={profilePicture}
                style={{
                  width: 40,
                  height: 40,
                }}
                alt="User"
                className="rounded-circle mb-2"
              />
              <p className="mt-2 mx-2 text-uppercase">
                {getUserNameFromStoreData(auth)}
              </p>
            </div>
            <hr />
            <ul
              className="nav nav-pills flex-column mb-auto"
              data-bs-spy="scroll"
            >
              {auth.user[0].role_name == "admin" && (
                <>
                  <li className="nav-item">
                    <NavLink
                      to="generate-tokens"
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link text-white"
                      }
                    >
                      <i class="fas fa-ticket-alt"></i> Generate Token(s)
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="tokens-detail"
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link text-white"
                      }
                    >
                      <i class="fas fa-check-square"></i> Valid Token(s)
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="view-profile"
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link text-white"
                      }
                    >
                      <i class="fas fa-user-edit"></i> My Profile
                    </NavLink>
                  </li>
                </>
              )}

              {/* SUPER ADMIN ROUTES */}
              {auth.user[0].role_name == "super-admin" && (
                <li>
                  <NavLink
                    to="verify-users"
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link text-white"
                    }
                  >
                    <i class="fas fa-users"></i> Verify Users
                  </NavLink>
                </li>
              )}
            </ul>
            <hr />
            <div className="dropdown">
              <button
                onClick={handleLogout}
                className="btn btn-success px-4 py-2 w-100"
              >
                Logout
              </button>
            </div>
          </div>

          {/* Main Content */}
          <main className="flex-grow-1 bg-light">
            <div className="d-flex justify-content-between align-items-center active text-white p-4 mb-4">
              {/* Header Section with Toggle */}
              <button
                className="btn btn-outline-light"
                style={{ marginRight: 20 }}
                onClick={toggleSidebar}
              >
                <i className="fa fa-bars"></i>
              </button>
              <h4>
                WELCOME {getUserNameFromStoreData(auth)} WJCWCF.COM ID:{" "}
                {auth.user[0].member_id}
              </h4>
              <div></div>
            </div>

            {/* Nested Routes Content */}
            <Outlet />
          </main>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default AdminDashboard;
